export function ProductDataListItem({
  title,
  subtitle,
}: {
  title: string;
  subtitle?: string | number;
}) {
  return subtitle !== '' && subtitle !== null ? (
    <li
      className='pb-3 uppercase text-muted-500'
      data-testid={'list-item-' + title}
    >
      <strong>{title}: </strong>
      {subtitle}
    </li>
  ) : null;
}
